import { apiClient } from "../config";

async function connectProtocol(id: any, data: any) {
  const url = `/admin/protocols/${id}/connect-program-form`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default connectProtocol;
